import { CatalogProductCardAvailable } from "shared/catalog/AvailableCatalog/CatalogProductCardAvailable";
import { OthersEntries } from "shared/catalog/OthersCatalog/others-catalog.helper";

type OtherItemProps = {
  item: NonNullable<OthersEntries>[number];
};

export const OtherItem = ({
  item: {
    isNew,
    isOutOfStock,
    minimumSubscriptionPrice,
    minimumUpfrontPrice,
    modelName,
    brand,
    originalUpfrontPrice,
    originalSubscriptionPrice,
    picture,
    availableColors,
    slug,
    tagSlugs,
  },
}: OtherItemProps) => (
  <CatalogProductCardAvailable
    key={slug}
    brand={brand}
    slug={slug}
    modelName={modelName}
    isNew={isNew}
    isOutOfStock={isOutOfStock}
    image={picture}
    colorCodes={availableColors}
    upfrontPrice={minimumUpfrontPrice}
    subscriptionPrice={minimumSubscriptionPrice}
    originalUpfrontPrice={originalUpfrontPrice}
    originalSubscriptionPrice={originalSubscriptionPrice}
    tagSlugs={tagSlugs}
  />
);
